/**
 * Generates a random hex token suitable for Meta's webhook verify_token field.
 * 32 hex chars (128 bits) is well over Meta's recommended minimum and easy to copy/paste.
 */
export const generateVerifyToken = (): string => {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
};
